export default __webpack_public_path__ + "static/media/6.5d475868.jpg";